import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.164 14.563c-.818 0-1.432-.204-1.844-.61-.406-.4-.61-1.005-.61-1.812V2.6c0-.807.204-1.41.61-1.812C1.732.383 2.346.18 3.164.18h10.672c.818 0 1.43.204 1.836.61.406.401.61 1.005.61 1.813v9.539c0 .807-.204 1.411-.61 1.812-.406.406-1.018.61-1.836.61H3.164Zm-.117-1.258h10.89c.35 0 .618-.094.805-.282.188-.182.281-.453.281-.812V4.844c0-.36-.093-.63-.28-.813-.188-.187-.457-.281-.806-.281H3.047c-.344 0-.61.094-.797.281-.188.183-.281.453-.281.813v7.367c0 .36.093.63.281.812.188.188.453.282.797.282Z"
    }, null, -1)
  ]))]))
}
export default { render: render }